export interface Schedule {
	id_: string;
	site_id: number;
	site_region: string;
	order: number;
	display_name: string;
	name: string;
	description: string;
	status: string;
	visible: boolean;
	scheduler_window_start: number;
	scheduler_window_end: number;
	legacy_id: number;
	date_created: string;
	last_modified: string;
	register_with_info360?: boolean;
}

export interface GetSchedulesParams {
	tenant_id: string;
	tenant_region: string;
}
